import { DiamondProxyVoteItem } from "./DiamondProxyVoteItem";

export default DiamondProxyVoteItem;